import IconComponent from "icons/IconComponent";

import MapPinIcon from "./MapPinIcon.svg";

export default (MapPinIcon as any) as IconComponent;
